<div id="settings-container" class="container">
  <h2>Manage My Account</h2>
  <div class="row">
    <div class="col-md-5">
      <mat-card appearance="outlined">
        <form [formGroup]="profile_form" (ngSubmit)="saveProfile($event)">
          <mat-card-title>Profile</mat-card-title>
          <mat-card-content>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>E-Mail</mat-label>
                <input matInput type="text" formControlName="email" />
              </mat-form-field>
            </div>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>Phone</mat-label>
                <input matInput type="text" formControlName="phone" mask="(000) 000-0000" />
              </mat-form-field>
            </div>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>Secondary Phone</mat-label>
                <input matInput type="text" formControlName="secondary_phone" mask="(000) 000-0000" />
              </mat-form-field>
            </div>
            <div class="input-cell">
              <mat-form-field>
                <mat-label>Secondary E-Mail</mat-label>
                <input matInput type="text" formControlName="secondary_email" />
              </mat-form-field>
            </div>
          </mat-card-content>
          <mat-card-actions>
            <p>
              <button mat-raised-button type="submit" color="primary" [disabled]="!profile_form.valid" style="width:250px">Save</button>
            </p>
            <nexus-form-result [model]="profile_result_model"></nexus-form-result>
          </mat-card-actions>
        </form>
      </mat-card>
      <mat-card appearance="outlined" *ngIf="this.settings_model.profile?.resident_portal_tutorial_url !== null && this.settings_model.profile?.resident_portal_tutorial_url !== ''">
          <mat-card-title>Tutorial Video</mat-card-title>
          <mat-card-actions>
            <p>
              <button mat-raised-button type="submit" color="primary" *ngIf="!opened" (click)="openDialog()">Watch Tutorial</button>
            </p>
          </mat-card-actions>
      </mat-card>
    </div>
    <div class="col-md-7">
      <app-credit-reporting-settings [settings_model]="settings_model"></app-credit-reporting-settings>

      <mat-card appearance="outlined">
        <mat-card-title>Contract Dates</mat-card-title>

        <div *ngFor="let contract_group of settings_model.contract_groups">
          <div class="contract-group-header">{{contract_group.address1 }} {{contract_group.address2 }}</div>
          <table class="table">
            <tr>
              <th>you + roommates</th>
              <th>start date</th>
              <th>end date</th>
            </tr>
            <tr *ngFor="let contract_date of contract_group.contract_dates">
              <td>{{contract_date.first_name}} {{contract_date.last_name}}</td>
              <td>{{contract_date.start_date | amDateFormat:'M/D/YYYY' }}</td>
              <td>{{contract_date.end_date | amDateFormat:'M/D/YYYY' }}</td>
            </tr>
          </table>
          <br />
          <br />
        </div>
        <ul>
          <!--<li>
              <div>
                  <a href="#">Invite roommates to sign up</a>
                  <p>All roommates who will be sharing the cost of utilities must be signed up with SimpleBills</p>
              </div>
          </li>-->
          <li>
            <div>
              <a href="https://simplebills.zendesk.com/hc/en-us/articles/115010459208-How-do-I-change-my-contract-dates-"
                target="_blank">Request a change to your contract dates</a>
              <p>Plans change and sometimes you need to stay longer or move out sooner. Let us know.</p>
            </div>
          </li>
          <li>
            <div> <a href="https://simplebills.zendesk.com/hc/en-us/articles/217389867-How-do-I-close-my-account-"
                target="_blank">Close my account</a></div>
          </li>
        </ul>
      </mat-card>
    </div>
  </div>

</div>
